import React from 'react';
import { Navigate } from 'react-router-dom';
import { useOrder } from '../context/OrderContext';

// Component to protect routes that require previous steps to be completed
const OrderRouteGuard = ({ children, requiredStep }) => {
  const { orderState } = useOrder();
  
  // Check if the route can be accessed based on the current step
  const canAccess = () => {
    switch (requiredStep) {
      case 1: // Services page - always accessible
        return true;
      case 2: // TranslitionOrder page - requires Services completion
        return orderState.servicesCompleted;
      case 3: // Payment1 page - requires TranslitionOrder completion
        return orderState.translationSummaryCompleted;
      default:
        return false;
    }
  };
  
  // If the user can access the route, render the children
  // Otherwise, redirect to the appropriate page
  if (canAccess()) {
    return children;
  } else {
    // Redirect to the appropriate page based on the current step
    if (requiredStep === 2) {
      return <Navigate to="/services" replace />;
    } else if (requiredStep === 3) {
      return <Navigate to="/translation-summary" replace />;
    } else {
      return <Navigate to="/" replace />;
    }
  }
};

export default OrderRouteGuard; 